import { createEntityAdapter, createSlice, EntityState } from "@reduxjs/toolkit";
import SavedSearchModel from "../../models/SavedSearchModel";
import { deleteSavedSearch, getAllSavedSearches, saveSearch, updateSavedSearch } from "./searchRequests";

export const savedSearchAdapter = createEntityAdapter<SavedSearchModel>({
  selectId: (search) => search.id,
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});

type SavedSearchState = {
  selectedSavedSearchId?: number | null;
} & EntityState<SavedSearchModel>;

const initialState: SavedSearchState = {
  selectedSavedSearchId: null,
  ...savedSearchAdapter.getInitialState(),
}

export const searchSlice = createSlice({
  name: 'savedSearch',
  initialState,
  reducers: {
    setCurrentSavedSearch: (state, action) => {
      state.selectedSavedSearchId = action.payload;
    }
  },
  extraReducers: builder =>
    builder
      .addCase(getAllSavedSearches.fulfilled, savedSearchAdapter.setAll)
      .addCase(updateSavedSearch.fulfilled, savedSearchAdapter.upsertOne)
      .addCase(saveSearch.fulfilled, savedSearchAdapter.addOne)
      .addCase(deleteSavedSearch.fulfilled, savedSearchAdapter.removeOne)
});

export const { setCurrentSavedSearch } = searchSlice.actions;